import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { MobileLayout } from '../layout/MobileLayout';
import { MobileScanner } from './MobileScanner';
import { MobileFiles } from './MobileFiles';
import { MobileCalendar } from './MobileCalendar';
import { MobileProfile } from './MobileProfile';
import { MobileDigitalOverview } from './MobileDigitalOverview';
import { MobileHealthOverview } from './MobileHealthOverview';
import { MobileMedicalRecords } from './MobileMedicalRecords';
import { MobileMedications } from './MobileMedications';
import { MobileAppointments } from './MobileAppointments';
import { MobileEmergencyContacts } from './MobileEmergencyContacts';
import { MobilePetsDashboard } from './MobilePetsDashboard';
import { MobileTravelDashboard } from './MobileTravelDashboard';
import { MobileLegalDashboard } from './MobileLegalDashboard';
import { MobileFinancialDashboard } from './MobileFinancialDashboard';
import { MobileNDISDashboard } from './MobileNDISDashboard';
import { MobileWellbeingDashboard } from './MobileWellbeingDashboard';
import { MobileBudgetingDashboard } from './MobileBudgetingDashboard';
import { 
  Shield, 
  Heart, 
  PawPrint, 
  Plane, 
  Building2, 
  Wallet, 
  Users, 
  BookOpen 
} from 'lucide-react';

export function MobileRouter() {
  return (
    <Routes>
      <Route path="/" element={<MobileLayout />}>
        <Route index element={<Navigate to="/mobile/dashboard" replace />} />
        <Route path="dashboard" element={<div />} /> {/* Dashboard content is handled in MobileLayout */}
        <Route path="scanner" element={<MobileScanner />} />
        <Route path="files" element={<MobileFiles />} />
        <Route path="calendar" element={<MobileCalendar />} />
        <Route path="profile" element={<MobileProfile />} />
        
        {/* Module routes */}
        <Route path="digital" element={<MobileDigitalOverview />} />
        <Route path="digital/security" element={<MobileDigitalOverview />} />
        <Route path="digital/devices" element={<MobileDigitalOverview />} />
        <Route path="digital/subscriptions" element={<MobileDigitalOverview />} />
        <Route path="health" element={<MobileHealthOverview />} />
        <Route path="health/providers" element={<MobileHealthOverview />} />
        <Route path="health/appointments" element={<MobileAppointments />} />
        <Route path="health/records" element={<MobileMedicalRecords />} />
        <Route path="health/medications" element={<MobileMedications />} />
        <Route path="health/emergency" element={<MobileEmergencyContacts />} />
        <Route path="pets" element={<MobilePetsDashboard />} />
        <Route path="travel" element={<MobileTravelDashboard />} />
        <Route path="legal" element={<MobileLegalDashboard />} />
        <Route path="financial" element={<MobileFinancialDashboard />} />
        <Route path="budgeting" element={<MobileBudgetingDashboard />} />

        <Route path="ndis" element={<MobileNDISDashboard />} />
        <Route path="wellbeing" element={<MobileWellbeingDashboard />} />
        <Route path="legacy" element={
          <div className="p-4">
            <div className="flex items-center gap-3 mb-4">
              <div className="p-2 bg-indigo-100 rounded-lg">
                <BookOpen className="w-6 h-6 text-indigo-600" />
              </div>
              <div>
                <h1 className="text-2xl font-bold text-gray-900">Legacy Management</h1>
                <p className="text-gray-600">Create memories, stories, and legacy content</p>
              </div>
            </div>
          </div>
        } />
        
        {/* Catch all */}
        <Route path="*" element={<Navigate to="/mobile/dashboard" replace />} />
      </Route>
    </Routes>
  );
} 